import {
  FilterTransactionDetails,
  FilterInvoicesDetails,
  FilterReconciliationDetails,
} from "../models";

// Authantication End points
export const authEndpoint = () => {
  return `auth/signin`;
};
export const LogoutEndpoint = () => {
  return `auth/logout`;
};
export const resetPasswordEndpoint = () => {
  return "/auth/resetPassword";
};

export const resetPasswordEndpointFirstLoging = () => {
  return "auth/updatePassword";
};

export const verifyOtpEndpoint = () => {
  return "auth/verifyOtp";
};
export const resendOtpEndpoint = () => {
  return "auth/sendOtp";
};

export const forgotPasswordEndpoint = () => {
  return "auth/forgetPassword";
};

export const accessApiKey = (id: string | number) => {
  return `auth/api-key/${id}`;
};

export const createAccessApiKey = () => {
  return `auth/api-key/generate`;
};

export const renewAccessApiKey = () => {
  return `auth/api-key/renew`;
};

// Merchant Secret endpoints
export const getMerchantSecretEndpoint = (merchantId: string) => {
  return `merchants/${merchantId}/secret`;
};

export const regenerateMerchantSecretEndpoint = (merchantId: string) => {
  return `merchants/${merchantId}/secret`;
};

const handleJoinValues = (Arr: any[] | any) => {
  if (Array.isArray(Arr)) {
    if (Arr.length == 1 && Arr[0].value === "") {
      return "";
    }
    var values = Arr?.map((a: any) => a.value);
    return values.join(",");
  } else {
    return Arr;
  }
};

// Users End points
export const editUserEndpoint = (id: string) => {
  return `/users/${id}?clientId=api-gateway`;
};

export const createUserEndpoint = () => {
  return "users";
};

export const usersByOutletEndpoint = (id: string) => {
  return `users/outlet/${id}`;
};

export const userSummaryEndpoint = (id: string) => {
  return `/users/${id}`;
};

// Outlets End points
export const addOutletEndpoint = (id: string) => {
  return `/merchants/${id}/outlets`;
};
export const getOutletEndpoint = (id: string) => {
  return `outlets/${id}`;
};
export const outletSummaryEndpoint = (id: string) => {
  return `outlets/${id}/summary`;
};

export const editOutletEndpoint = (id: string) => {
  return `outlets/${id}`;
};

// Terminals End points
export const getTerminalsByOutletEndpoint = (id: string) => {
  return `terminals/outlet/${id}`;
};
export const getTerminalsByUserEndpoint = (id: string) => {
  return `terminals/user/${id}`;
};
export const terminalSummaryEndpoint = (tsn: number) => {
  return `terminals/${tsn}/summary`;
};
export const deleteTerminalEndpoint = (terminalId: string) => {
  return `/terminals/${terminalId}/archive`;
};

export const addTerminalEndPoint = (id: string) => {
  return `merchants/${id}/addTerminal`;
};

export const EditTerminalEndPoint = (tsn: string) => {
  return `/terminals/${tsn}`;
};

// Transactions End points
export const transationByTerminalEndpoint = (tsn: number) => {
  return `transactions/financial/terminals/${tsn}`;
};
export const transationByUserEndpoint = (id: string) => {
  return `transactions/financial/users/${id}`;
};

export const transactionByMerchantEndpoint = (id: string) => {
  return `/transactions/financial/merchants/${id}`;
};
export const getTranactionRecieptDetailsEndpoint = (id: string) => {
  return `/transactions/response/${id}/`;
};
export const getPublicTranactionRecieptDetailsEndpoint = (id: string) => {
  return `/transactions/receiptData/response/${id}/`;
};
export const sendTransactionReceiptByEmailEndpoint = () => {
  return `/transactions/sendTransactionReceiptByEmail`;
};

export const getReconciliationRecieptDetailsEndpoint = (
  tsn: string,
  id: string,
) => {
  return `/reconciliation/v1/reconciliationStatus/tsn/${tsn}/reconciliationStatusId/${id}`;
};

export const getMerchantTodayBalanceEndPoint = (id: string) => {
  return `/transactions/merchantTodayBalance/${id}`;
};

export const getTopUsedTerminalEndPoint = (
  id: string,
  startDate?: string,
  endDate?: string,
) => {
  const params = new URLSearchParams({
    merchantId: id,
    trxStatus: "Success",
  });
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  return `/transactions/topUsedTerminal?${params.toString()}`;
};
export const getMerchantTransactionCountEndpoint = (
  id: string,
  startDate?: string,
  endDate?: string,
  range?: string,
) => {
  const params = new URLSearchParams({ trxStatus: "Success" });
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  if (range) params.set("range", range);
  return `/transactions/merchantTransactionCountChart/${id}?${params.toString()}`;
};
export const getSalesForCurrentPreviousMonthEndpoint = (
  id: string,
  startDate?: string,
  endDate?: string,
) => {
  const params = new URLSearchParams({
    operationType: "1",
    trxStatus: "Success",
  });
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  return `/transactions/salesComparisonChart/${id}?${params.toString()}`;
};
export const getSchemeusUsageEndpoint = (id: string) => {
  return `/transactions/schemeChart/${id}`;
};
export const getTerminalsLast7daysTransactionEndpoint = (
  id: string,
  operationType: string,
  startDate?: string,
  endDate?: string,
  range?: string,
) => {
  const params = new URLSearchParams({
    operationType,
    trxStatus: "Success",
  });
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  if (range) params.set("range", range);
  return `/transactions/terminalsTransactionChart/${id}?${params.toString()}`;
};
export const getOutletlast7DaysTransactionEndpoint = (
  id: string,
  operationType: string,
  startDate?: string,
  endDate?: string,
  range?: string,
) => {
  return getTerminalsLast7daysTransactionEndpoint(
    id,
    operationType,
    startDate,
    endDate,
    range,
  );
};

// Merchants End points

export const createMerchantEndpoint = () => {
  return `merchants/`;
};
export const getListOfMerchantEndpoint = () => {
  return `merchants/filterAndPagination`;
};

export const getListOfMerchantPartnersEndpoint = (partnerId: string) => {
  return `recurring-payments/partners/${partnerId}/merchants`;
};

export const getMerchantEndpoint = (id: string, type?: string) => {
  if (type === "checkout") {
    return `merchants/checkout/${id}/`;
  }
  return `merchants/${id}/`;
};
export const editMerchantEndpoint = (id: string) => {
  return `merchants/${id}`;
};
export const merchantSummaryEndpoint = (id: string) => {
  return `merchants/${id}/summary`;
};

export const getOutletsByMerchantEndpoint = (id: string) => {
  return `merchants/${id}/outlets`;
};

export const getOutletsByPartnerEndpoint = (id: string) => {
  return `partners/users/${id}`;
};

export const getTerminalsByMerchantEndpoint = (id: string) => {
  return `merchants/${id}/terminals`;
};
export const getMerchantAvailableTerminals = (id: string) => {
  return `/terminals/availableTerminal/${id}`;
};

export const editMerchantAvailableTerminalEndpoint = (
  id: string,
  tsn: string,
) => {
  return `/terminals/availableTerminal/id/${id}/tsn/${tsn}`;
};

export const usersByMerchantEndpoint = (id: string) => {
  return `merchants/${id}/users`;
};

// Currency
export const getCurrencyEndpoint = () => {
  return `merchants/currency/`;
};

//Business Category
export const getBusinessCategoryEndpoint = () => {
  return `merchants/businessCategory`;
};

export const getCountriesCitiesEndPoint = () => {
  return `merchants/countries`;
};

//Filter Serach
export const getFilterSearchEndPoint = () => {
  return `merchants/filterAndPagination`;
};

export const addTerminalTmsCardSchemeEndPoint = () => {
  return `tmscardscheme/addTmscardScheme`;
};
export const addTerminalRetailerDataEndPoint = () => {
  return `retailer/addRetailer`;
};

//reconcilation

export const getReconcilationHistoryEndpoint = (txnId: string) => {
  return `reconciliation/json/history/${txnId}`;
};

export const postRecuringPaymentCardholder = () => {
  return "recurring-payments/cardholders";
};

export const updateRecurringPaymentCardholder = () => {
  return "recurring-payments/cardholders/update-after-bank-success";
};

export const filterReconciliationEndPoint = (
  FilterReconciliationDetails: FilterReconciliationDetails,
  pageNumber: any,
  merchantId?: string,
  partnerId?: string,
) => {
  const {
    pageSize,
    sortDirection,
    sortBy,
    terminalId,
    id,
    reconciliationStatus,
    requestedBy,
    startDate,
    endDate,
  } = FilterReconciliationDetails;

  const baseUrl = `reconciliation/filterReconciliation?PageSize=${pageSize}&pageNumber=${pageNumber}&sortDirection=${sortDirection}&SortBy=${sortBy}&terminalId=${handleJoinValues(
    terminalId,
  )}&id=${id}&reconciliationStatus=${handleJoinValues(
    reconciliationStatus,
  )}&requestedBy=${handleJoinValues(
    requestedBy,
  )}&merchantId=${merchantId}&partnerId=${partnerId}`;

  if (startDate === "" && endDate === "") {
    return baseUrl;
  }

  if (startDate === "" || endDate === "") {
    const date = startDate === "" ? endDate : startDate;
    return `${baseUrl}&${startDate === "" ? "endDate" : "startDate"}=${date}`;
  }

  return `${baseUrl}&startDate=${startDate}&endDate=${endDate}`;
};

//E-invoices
export const CreateInvoiceEndPoint = () => {
  return `merchants/invoice`;
};

//GET E-invoices list for Merchant
export const GetInvoicesListEndPoint = (merchantId: string) => {
  return `merchants/invoice/getinvoiceByMerchantId/${merchantId}`;
};
//Filter E-invoices list for merchant
export const filterInvoicesEndPoint = (
  FilterInvoicesDetails: FilterInvoicesDetails,
  pageNumber: any,
  merchantId?: string,
) => {
  return `merchants/filterInvoice?PageSize=${
    FilterInvoicesDetails.pageSize
  }&pageNumber=${pageNumber}&sortDirection=${
    FilterInvoicesDetails.sortDirection
  }&SortBy=${FilterInvoicesDetails.sortBy}&invoiceId=${
    FilterInvoicesDetails.invoiceId
  }&merchantId=${merchantId}&startDate=${
    FilterInvoicesDetails.startDate
  }&endDate=${FilterInvoicesDetails.endDate}&invoiceTotalFrom=${
    FilterInvoicesDetails.invoiceTotalFrom
  }&invoiceTotalTo=${
    FilterInvoicesDetails.invoiceTotalTo
  }&invoiceStatus=${handleJoinValues(
    FilterInvoicesDetails.invoiceStatus,
  )}&name=${FilterInvoicesDetails.name}&email=${
    FilterInvoicesDetails.email
  }&vatId=${FilterInvoicesDetails.vatId}&address=${
    FilterInvoicesDetails.address
  }&phoneNum=${FilterInvoicesDetails.phoneNum}&partnerId=${
    FilterInvoicesDetails?.partnerId
  }`;
};

//Get Merchant payment configuration
export const GetMerchantPaymentConfigEndPoint = (merchantId: string) => {
  return `merchants/merchantpaymentconfiguration/${merchantId}`;
};

export const paymentResonse = (
  selectedPlanId: string,
  id: string,
  invoiceId: string,
) => {
  return `recurring-payments/plans/${selectedPlanId}/merchants/${id}/order/${invoiceId}`;
};

//post payment configuration

export const addMerchantPaymentConfigEndPoint = () => {
  return `merchants/merchantpaymentconfiguration`;
};

export const updateMerchantPaymentConfigEndPoint = () => {
  return `merchants/merchantpaymentconfiguration//update/`;
};

//Get invoice by merchant id and invoixe id ]
export const getMerchantInvoiceEndPoint = (id: string, merchantId: string) => {
  return `merchants/invoice/getinvoice?invoiceId=${id}&merchantId=${merchantId}`;
};

//get Payment Url from express Pay
export const getRedirectPaymentUrlEndPoint = (
  merchantId: string,
  id: string,
) => {
  return `merchants/invoice/getMerchantPayment?merchantId=${merchantId}&invoiceId=${id}`;
};

//update  invoice status
export const updateInvoiceStatusEndPoint = (invoiceid: string) => {
  return `merchants/invoice/updateInvoiceStatus?invoiceId=${invoiceid}`;
};

export const DownloadInvoiceEndPoint = (invoiceid: string) => {
  return `/merchants/filestorage/download/${invoiceid}`;
};

export const downloadMerchantInvoiceEndPoint: any = (
  merchantId: string,
  invoiceid: string,
) => {
  return `/merchants/${merchantId}/invoice/download/${invoiceid}`;
};
export const updateInstallmentStatusEndpoint = (invoiceId: string) => {
  return `recurring-payments/payments/invoice/${invoiceId}/status`;
};
export const updateInstallmentStatusCardHolder = (invoiceId: string) => {
  return `recurring-payments/cardholders/invoice/${invoiceId}/status`;
};

export const DownloadNotesAttachementEndPoint = (templateId: string) => {
  return `recurring-payments/template/${templateId}/download`;
};

export const buildFilterTransactionQuery = (
  FilterTransactionDetails: FilterTransactionDetails,
  pageNumber: any,
  merchantId?: string,
  userId?: string,
  outletId?: string,
  partnerIds?: string[],
) => {
  const queryParams = [];

  // Check and add parameters to the query string if they are not empty
  if (FilterTransactionDetails.pageSize) {
    queryParams.push(`PageSize=${FilterTransactionDetails.pageSize}`);
  }

  if (FilterTransactionDetails.amountFrom !== undefined) {
    queryParams.push(`amountFrom=${FilterTransactionDetails.amountFrom}`);
  }

  if (FilterTransactionDetails.RRN) {
    queryParams.push(`rrn=${FilterTransactionDetails.RRN}`);
  }

  if (FilterTransactionDetails.amountTo !== undefined) {
    queryParams.push(`amountTo=${FilterTransactionDetails.amountTo}`);
  }
  // ${handleJoinValues(FilterTransactionDetails.cardType)
  if (FilterTransactionDetails.cardType.length > 0) {
    queryParams.push(
      `cardType=${FilterTransactionDetails.cardType
        ?.map((obj) => obj.value)
        .join(",")}`,
    );
  }

  if (FilterTransactionDetails.tsn) {
    queryParams.push(`tsn=${FilterTransactionDetails.tsn}`);
  }

  if (FilterTransactionDetails.transactionStatus.length > 0) {
    queryParams.push(
      `status=${handleJoinValues(FilterTransactionDetails.transactionStatus)}`,
    );
  }

  if (FilterTransactionDetails.operationType.length > 0) {
    queryParams.push(
      `operationType=${handleJoinValues(
        FilterTransactionDetails.operationType,
      )}`,
    );
  }

  if (FilterTransactionDetails.ReconcilationStatus.length > 0) {
    queryParams.push(
      `reconciliationStatus=${handleJoinValues(
        FilterTransactionDetails.ReconcilationStatus,
      )}`,
    );
  }

  if (FilterTransactionDetails.startDate) {
    queryParams.push(`startDate=${FilterTransactionDetails.startDate}`);
  }

  if (FilterTransactionDetails.endDate) {
    queryParams.push(`endDate=${FilterTransactionDetails.endDate}`);
  }

  if (FilterTransactionDetails.transactionType.length > 0) {
    queryParams.push(
      `transactionType=${handleJoinValues(
        FilterTransactionDetails.transactionType,
      )}`,
    );
  }

  if (outletId) {
    queryParams.push(`outLetId=${outletId}`);
  }

  if (merchantId) {
    queryParams.push(`merchantId=${merchantId}`);
  }

  if (partnerIds && partnerIds.length > 0) {
    const ids = Array.isArray(partnerIds) ? partnerIds : [partnerIds];
    ids.forEach((id) => queryParams.push(`partnerId=${id}`));
  }

  if (userId) {
    queryParams.push(`loggedUserId=${userId}`);
  }

  queryParams.push(`pageNumber=${pageNumber}`);

  if (FilterTransactionDetails.sortDirection) {
    queryParams.push(`sortDirection=${FilterTransactionDetails.sortDirection}`);
  }

  if (FilterTransactionDetails.sortBy) {
    queryParams.push(`SortBy=${FilterTransactionDetails.sortBy}`);
  }

  return queryParams.join("&");
};

export const filterTransactionEndPoint = (
  filter: FilterTransactionDetails,
  pageNumber: any,
  merchantId?: string,
  userId?: string,
  outletId?: string,
  partnerIds?: string[],
) => {
  const queryString = buildFilterTransactionQuery(
    filter,
    pageNumber,
    merchantId,
    userId,
    outletId,
    partnerIds,
  );
  return `transactions/filterTransaction?${queryString}`;
};

export const recurringPlansEndpointFilter = (searchName?: string) => {
  if (searchName && searchName.trim() !== "") {
    return `/recurring-payments/plans?name=${encodeURIComponent(searchName)}`;
  }
  return `/recurring-payments/plans`;
};

export const downloadTransactionExcelEndPoint = (
  filter: FilterTransactionDetails,
  pageNumber: any,
  merchantId?: string,
  userId?: string,
  outletId?: string,
  partnerIds?: string[],
) => {
  const queryString = buildFilterTransactionQuery(
    filter,
    pageNumber,
    merchantId,
    userId,
    outletId,
    partnerIds,
  );
  return `transactions/filterTransaction/download?${queryString}`;
};

//Send Invoice notication to customer  with attachment
export const SendInvoiceNotificationEndPoint = () => {
  return `merchants/sendInvoiceNotification`;
};

//payment Gateway payment checkout
export const ExpressPayPurchaseEndPoint = () => {
  return `payment/execute`;
};

export const ExpressPayPaymentStatusEndPoint = () => {
  return `payment/status`;
};

export const checkoutOrderDetailsEndPoint = (
  oid: string,
  merchantId: string,
) => {
  return `payment/orderdtl`;
};

export const orderInitiateForRediectUrlEndpoint = () => {
  return `payment/initiate`;
};

export const PaymentStatusEndpoint = () => {
  return `clictopay/order-status`;
};

export const getApplePaymerchantConfigEndPoint = (merchantId: string) => {
  return `applepay/merchants/find/${merchantId}`;
};

export const merchantValidationforApplePayEndpoint = (
  edfaPayMerchantID: string,
) => {
  return `applepay/merchants/validate/${edfaPayMerchantID}`;
};

export const applePayExpresspayVirtualPaymentEndpoint = () => {
  return `applepay/merchants/express/finalPay`;
};

export const expressPaySessionForApplePayEndpoint = () => {
  return `applepay/merchants/express/startsession`;
};

//get payment transaction data by filetrs
export const getTransactionsEndpoint = (
  expressPayMerchantId: string,
  formattedDates: { startDate?: string; endDate?: string },
  formData: {
    amount?: string;
    cardType?: string;
    merchentOrderId?: string;
    country?: string;
    phone?: string;
    email?: string;
    transactionType?: string;
    transactionStatus?: string;
    searchOffset?: string;
    minAmount?: string;
    maxAmount?: string;
  },
  role?: string,
  pageNumber?: number,
  pageSize?: number,
  searchOffset?: string,
) => {
  const queryParams = [];

  if (formattedDates.startDate) {
    queryParams.push(
      `startDate=${encodeURIComponent(formattedDates.startDate)}`,
    );
  }
  if (formattedDates.endDate) {
    queryParams.push(`endDate=${encodeURIComponent(formattedDates.endDate)}`);
  }
  if (formData.amount) {
    queryParams.push(`amount=${encodeURIComponent(formData.amount)}`);
  }
  if (formData.minAmount) {
    queryParams.push(`minAmount=${encodeURIComponent(formData.minAmount)}`);
  }
  if (formData.maxAmount) {
    queryParams.push(`maxAmount=${encodeURIComponent(formData.maxAmount)}`);
  }

  if (formData.cardType) {
    queryParams.push(`cardType=${encodeURIComponent(formData.cardType)}`);
  }
  if (formData.merchentOrderId) {
    queryParams.push(
      `merchantOrderId=${encodeURIComponent(formData.merchentOrderId)}`,
    );
  }
  if (formData.country) {
    queryParams.push(`country=${encodeURIComponent(formData.country)}`);
  }
  if (formData.phone) {
    queryParams.push(`phone=${encodeURIComponent(formData.phone)}`);
  }
  if (formData.email) {
    queryParams.push(`email=${encodeURIComponent(formData.email)}`);
  }
  if (formData.transactionType) {
    queryParams.push(
      `transactionType=${encodeURIComponent(formData.transactionType)}`,
    );
  }
  if (formData.transactionStatus) {
    queryParams.push(
      `transactionStatus=${encodeURIComponent(formData.transactionStatus)}`,
    );
  }
  if (searchOffset) {
    queryParams.push(`searchOffset=${encodeURIComponent(searchOffset)}`);
  }
  if (expressPayMerchantId && role != "partner") {
    queryParams.push(`userId=${encodeURIComponent(expressPayMerchantId)}`);
  }
  if (pageNumber) {
    queryParams.push(`pageNo=${pageNumber}`);
  }
  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  return pageNumber && pageSize
    ? `/paymentGateway/v1/transactions${queryString}`
    : `paymentGateway/v1/transactions/downloadReport${queryString}`;
};

export const getPaymentGatewayDashboardSummaryData = () => {
  return `paymentGateway/v1/transactions/payment/stats`;
};

export const getPaymentGatewayDashboardHighLightsData = () => {
  return `paymentGateway/v1/transactions/payment/stats`;
};

export const getPaymentMethodsData = () => {
  return `/paymentGateway/v1/transactions/currency/stats`;
};

export const getGeoPaymentsData = () => {
  return `paymentGateway/v1/transactions/geography`;
  //for testing
  // return `paymentGateway/v1/merchants/2905b0cc-a944-11ec-837c-9677b5aab9bd/transactions/geography?startDate=2022-08-04T00:00:00Z&endDate=2023-06-06T00:00:00Z`
};

export const getPaymentChartData = () => {
  return `/paymentGateway/v1/transactions/duration/stats`;
};

export const getTamaraTransaction = () => {
  return `/tamarapay/order-list`;
};

export const addApplepayMerchantConfigEndoint = () => {
  return `/applepay/merchants/add`;
};

export const tamaraPaymentOptionEndpoint = () => {
  return "/tamarapay/payment-option";
};

export const tamaraInitiateOrderEndpoint = () => {
  return "/tamarapay/initiate";
};

export const tamaraCheckoutOrderEndpoint = () => {
  return "/tamarapay/checkout";
};

export const tamaraRefundOrderEndpoint = () => {
  return "/tamarapay/refund";
};
export const tamaraCancelOrderEndpoint = () => {
  return "/tamarapay/cancel";
};

export const tamaraCaptureAmountOrderEndpoint = () => {
  return "/tamarapay/capture";
};

export const tabbyInitiateOrderEndpoint = () => {
  return "/payment/initiate";
};

export const tabbyCheckoutOrderEndpoint = () => {
  return "/tabby-pay/checkout";
};

export const tabbyRefundOrderEndpoint = () => {
  return "/tabby-pay/refund";
};
export const getTabbyTransactionEndpoint = () => {
  return `/tabby-pay/order-list`;
};

export const addTabbyConfigEndPoint = () => {
  return `/tabby-pay/merchantConfiguration`;
};
export const EditTabbyConfigEndPoint = () => {
  return `/tabby-pay/updateMerchantConfiguration/`;
};
export const getTabbyConfigEndpoint = (MerchantId: string) => {
  return `/tabby-pay/findMerchantConfiguration/${MerchantId}`;
};
export const DeleteTabbyConfigEndpoint = (MerchantId: string) => {
  return `/tabby-pay/deleteMerchantConfiguration/${MerchantId}`;
};
export const ActivateTabbyConfigEndpoint = (MerchantId: string) => {
  return `/tabby-pay/reactivateMerchantConfiguration/${MerchantId}`;
};

export const expressPayCardPaymentRefundEndpoint = () => {
  return "/payment/refund";
};

export const expressPayApplepayRefundEndpoint = () => {
  return "/applepay/merchants/express/refund";
};

export const createSadadBillEndpoint = () => {
  return "/billAndPaymentGateway/v1/bill";
};

export const urpayInitiateEndpoint = () => {
  return "/urpay/initiate";
};

export const urpayExcuteEndpoint = () => {
  return "/urpay/execute";
};

export const getBindingListEndPoint = () => {
  return "/clictopay/getbinding";
};

export const unbindingClicToPayCardsEndpoint = () => {
  return "clictopay/unbinding";
};

export const payWithBindingIdEndpoint = () => {
  return "/clictopay/checkout-binding";
};
export const clicktoPayCheckoutEndpoint = () => {
  return "/clictopay/checkout";
};

export const getmerchantCallBackUrlEndpoint = () => {
  return "/clictopay/get-merchant-url";
};

export const getClicTOPayTrxStatusEndpoint = () => {
  return "/clictopay/order-status";
};

export const addCardPayMerchantConfigEndpoint = () => {
  return `payment/paymentgateway/add`;
};

export const updateCardPaymentMerchantConfigEndpoint = () => {
  return `payment/paymentgateway/update`;
};

export const findMerchantPaymentConfigEndpoint = (
  expressPayMerchantId: any,
) => {
  return `payment/paymentgateway/find/${expressPayMerchantId}`;
};

export const addUrpayMerchantConfigEndpoint = () => {
  return `/urpay/merchantConfiguration`;
};

/* export const manafithCheckoutEndpoint=()=>{
  return  ``
} */

export const updateUrpayConfigEndpoint = () => {
  return `/urpay/updateMerchantConfiguration`;
};

export const findUrpayConfigEndpoint = (expressPayMerchantId: any) => {
  return `/urpay/findMerchantConfiguration/${expressPayMerchantId}`;
};

export const findAppleConfigEndpoint = (expressPayMerchantId: any) => {
  return `applepay/merchants/find/${expressPayMerchantId}`;
};

export const updateAppleConfigEndpoint = () => {
  return `/applepay/merchants/update`;
};

export const addManafithConfigEndPoint = () => {
  return `/manafithpay/merchantConfiguration`;
};
export const EditManafithConfigEndPoint = () => {
  return `/manafithpay/updateMerchantConfiguration`;
};
export const getManafithConfigEndpoint = (MerchantId: string) => {
  return `manafithpay/findMerchantConfiguration/${MerchantId}`;
};
export const DeleteManafithConfigEndpoint = (MerchantId: string) => {
  return `/manafithpay/deleteMerchantConfiguration/${MerchantId}`;
};
export const ActivateManafithConfigEndpoint = (MerchantId: string) => {
  return `/manafithpay/reactivateMerchantConfiguration/${MerchantId}`;
};

export const addTamaraConfigEndPoint = () => {
  return `/tamarapay/merchantConfiguration`;
};
export const EditTamaraConfigEndPoint = () => {
  return `/tamarapay/updateMerchantConfiguration/`;
};
export const getTamaraConfigEndpoint = (MerchantId: string) => {
  return `/tamarapay/findMerchantConfiguration/${MerchantId}`;
};
export const DeleteTamaraConfigEndpoint = (MerchantId: string) => {
  return `/deleteMerchantConfiguration/${MerchantId}`;
};
export const ActivateTamaraConfigEndpoint = (MerchantId: string) => {
  return `/tamarapay/reactivateMerchantConfiguration/${MerchantId}`;
};

export const addClickToPayConfigEndPoint = () => {
  return `/clictopay/merchantConfiguration`;
};
export const EditClickToPayConfigEndPoint = () => {
  return `/clictopay/updateMerchantConfiguration/`;
};
export const getClickToPayConfigEndpoint = (MerchantId: string) => {
  return `/clictopay/findMerchantConfiguration/${MerchantId}`;
};
export const DeleteClickToPayConfigEndpoint = (MerchantId: string) => {
  return `/deleteMerchantConfiguration/${MerchantId}`;
};
export const ActivateClickToPayConfigEndpoint = (MerchantId: string) => {
  return `/clictopay/reactivateMerchantConfiguration/${MerchantId}`;
};

export const addSadadConfigEndPoint = () => {
  return `/billAndPaymentGateway/v1/configGateway/config/add`;
};
export const EditSadadConfigEndPoint = () => {
  return `/billAndPaymentGateway/v1/configGateway/config/update`;
};
export const getSadadConfigEndpoint = (MerchantId: string) => {
  return `/billAndPaymentGateway/v1/configGateway/config/find/${MerchantId}`;
};
export const DeleteSadadConfigEndpoint = (MerchantId: string) => {
  return `/billAndPaymentGateway/v1/configGateway/config/deactivate/${MerchantId}`;
};
export const ActivateSadadConfigEndpoint = (MerchantId: string) => {
  return `/billAndPaymentGateway/v1/configGateway/config/reactivate/${MerchantId}`;
};

export const addMerchantRegistration = () => {
  return `/merchantonboarding/onboard`;
};

export const getMerchantOnlineRegistrationEndoint = () => {
  return `/merchants/merchantOnBoard/filter`;
};

export const deleteMerchantOnlineRegistrationEndoint = (
  MerchantOnlineRegisterId: string,
) => {
  return `/merchants/merchantOnBoard/${MerchantOnlineRegisterId}`;
};

export const updateMerchantRegistrationEndpoint = (
  MerchantOnlineRegisterId: string,
) => {
  return `/merchants/merchantOnBoard/update/${MerchantOnlineRegisterId}`;
};

export const addNewCustomerEndpoint = () => {
  return `merchants/addCustomerMaintenance`;
};

export const getCustomersListEndpoint = (
  keyword: string,
  expressPayMerchantId: any,
) => {
  return `merchants/customerMaintenance?keyword=${keyword}&merchantId=${expressPayMerchantId}`;
};

export const editCustomerEndpoint = (expressPayMerchantId: any) => {
  return `merchants/${expressPayMerchantId}/customers/`;
};

export const deleteCustomerEndpoint = (
  expressPayMerchantId: any,
  customerId: any,
) => {
  return `merchants/${expressPayMerchantId}/customers/${customerId}`;
};

export const addNewProductEndpoint = () => {
  return `merchants/createProduct`;
};

export const getProductListEndpoint = (
  keyword: string,
  expressPayMerchantId: any,
) => {
  return `merchants/productMaintenance?keyword=${keyword}&merchantId=${expressPayMerchantId}`;
};

export const deleteProductEndpoint = (
  expressPayMerchantId: any,
  productId: string,
) => {
  return `merchants/${expressPayMerchantId}/products/${productId}`;
};

export const editProductEndpoint = (expressPayMerchantId: any) => {
  return `/merchants/${expressPayMerchantId}/products/`;
};

export const createProductsTemplateEndpoint = (merchantId: string) => {
  return `/merchants/${merchantId}/products/template`;
};

export const getProductsTemplatesEndpoint = (merchantId: string) => {
  return `/merchants/${merchantId}/products/templates`;
};

export const getProductsTemplateEndpoint = (
  merchantId: string,
  templateId: string,
) => {
  return `/merchants/${merchantId}/products/template/${templateId}`;
};

export const getInvoicesByTemplateEndpoint = (
  merchantId: string,
  templateId: string,
) => {
  return `/merchants/${merchantId}/products/template/${templateId}/invoices`;
};

export const getCreateInvoicesByTemplateEndpoint = (
  merchantId: string,
  templateId: string,
) => {
  return `/merchants/${merchantId}/products/template/${templateId}/invoice`;
};

export const deleteMerchant = (merchantId: string) => {
  return `/merchants/${merchantId}`;
};

export const getTerminalsListEndpoint = (
  keyword?: string,
  pageNumber?: number,
  pageSize?: number,
  merchantId?: string,
  terminalStatus?: string,
  isDeleted?: string,
  partnerId?: string,
) => {
  return `terminals/filter`;
};

export const deleteUserEndpoint = (userId: string) => {
  return `/users/${userId}/status`;
};

export const getCountriesEndpoint = (
  keyword: string,
  pageNumber: number,
  pageSize: number,
  isActive?: { value: string; label: string }[],
) => {
  return `merchants/countries/?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&isActive=${isActive
    ?.map((obj) => obj.value)
    .join(",")}`;
};

export const addNewCountryEndpoint = () => {
  return `merchants/countries/`;
};

export const deleteCountryEndpoint = (countryId: string) => {
  return `merchants/countries/${countryId}`;
};

export const getCitiesEndpoint = (
  _token: any,
  keyword: string,
  pageNumber: number,
  pageSize: number,
  isActive?: { value: string; label: string }[],
) => {
  return `merchants/city/?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&isActive=${isActive
    ?.map((obj) => obj.value)
    .join(",")}`;
};

export const addNewCityEndpoint = () => {
  return `merchants/city/`;
};

export const deleteCityEndpoint = (countryId: string) => {
  return `merchants/city/${countryId}`;
};

export const getAllCurrenciesEndpoint = (
  keyword: string,
  pageNumber: number,
  pageSize: number,
  isActive?: string,
) => {
  return `merchants/currencies?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&isActive=${isActive}`;
};

export const addNewCurrencyEndpoint = () => {
  return `merchants/currencies`;
};

export const deleteCurrencyEndpoint = (currencyId: string) => {
  return `merchants/currency/${currencyId}`;
};

export const getAllBusinessCategoryEndpoint = (
  pageNumber: number,
  pageSize: number,
  status: { value: string; label: string }[],
  businessCategoryName: string,
  businessCategoryId: string,
  businessCategoryCode: string,
) => {
  return `merchants/businessCategory/findAll/?pageNumber=${pageNumber}&pageSize=${pageSize}&status=${status
    ?.map((obj) => obj.value)
    .join(
      ",",
    )}&businessCategoryId=${businessCategoryId}&businessCategoryName=${businessCategoryName}&businessCategoryCode=${businessCategoryCode}`;
};

export const addBusinessCategoryEndpoint = () => {
  return `merchants/businessCategory/add`;
};

export const updateBusinessCategoryEndpoint = () => {
  return `merchants/businessCategory/update`;
};

export const reactivateBusinessCategory = (categoryId: any) => {
  return `merchants/businessCategory/reactivate/${categoryId}/`;
};

export const deactivateBusinessCategory = (categoryId: any) => {
  return `merchants/businessCategory/deactivate/${categoryId}/`;
};

export const addTmsEndPoint = () => {
  return `merchants/tmscardscheme/addTmsCardScheme`;
};

export const getAllTmsEndpoint = (
  pageNumber: number,
  pageSize: number,
  trsm?: string,
  cardSchemeId?: string,
  cardSchemeNameEn?: string,
  status?: { value: string; label: string }[],
) => {
  return `merchants/tmscardscheme/filterAndPagination/?pageNumber=${pageNumber}&pageSize=${pageSize}&cardSchemeNameEn=${cardSchemeNameEn}&cardSchemeId=${cardSchemeId}&status=${status
    ?.map((obj) => obj.value)
    .join(",")}&trsm=${trsm}`;
};

export const reactivateTmsEndpoint = (trsm: any, cardschemeid: any) => {
  return `merchants/tmscardscheme/reactivateTmsCardSchemeData/${trsm}/${cardschemeid}/`;
};

export const deactivateTmsEndpoint = (trsm: any, cardschemeid: any) => {
  return `merchants/tmscardscheme/deactivateTmsCardSchemeData/${trsm}/${cardschemeid}/`;
};

export const getAllretailerEndpoint = (
  pageNumber: number,
  pageSize: number,
  trsm?: string,
  providerMerchantIdretailerNameEn?: string,
  providerMerchantId?: string,
  retailerNameEnglish?: string,
  status?: { value: string; label: string }[],
) => {
  return `merchants/retailer/filterAndPagination/?pageSize=${pageSize}&pageNumber=${pageNumber}&createdDate=&trsm=${trsm}&providerMerchantId=${providerMerchantId}&retailerNameEnglish=${retailerNameEnglish}&status=${status
    ?.map((obj) => obj.value)
    .join(",")}`;
};

export const editRetailerEndpoint = () => {
  return `merchants/retailer/updateRetailer`;
};

export const addRetailerEndpoint = () => {
  return `merchants/retailer/addRetailer`;
};

//Partner Crud operation
export const getAllPartnerEndpoint = (
  pageNumber: number,
  pageSize: number,
  keyword: string,
) => {
  return `merchants/partner?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
};
export const getAllPartnerRecurringEndpoint = (
  pageNumber?: number,
  pageLength?: number,
) => {
  const queryParams: string[] = [];

  if (pageNumber !== undefined) {
    queryParams.push(`pageNumber=${pageNumber}`);
  }

  if (pageLength !== undefined) {
    queryParams.push(`pageLength=${pageLength}`);
  }

  return queryParams.length > 0
    ? `recurring-payments/partners?${queryParams.join("&")}`
    : `recurring-payments/partners`;
};
export const addPartnerEndpoint = () => {
  return `merchants/partner`;
};

export const updatePartnerEndpoint = () => {
  return `merchants/partner`;
};

export const deletePartnerEndpoint = (partnerId: any) => {
  return `merchants/partner/${partnerId}`;
};

export const getPartnerByIdEndpoint = (partnerId: any) => {
  return `merchants/partner/${partnerId}`;
};

export const getAllUsersEndpoint = (
  page: number,
  size: number,
  keyword: string,
) =>
  // `/users?page=${page}&size=${size}&keyword=${q}`;
  // `merchants/partner?keyword=${keyword}&pageNumber=${page}&pageSize=${size}`;
  `partners/users?keyword=${keyword}&pageNumber=${page}&pageSize=${size}`;

export const addUserEndpoint = (partnerId: string) =>
  `partners/${partnerId}/users`;
export const updateUserEndpoint = (partnerId: any) =>
  `/partners/users/${partnerId}`;
export const addParenUserEndpoint = () => `/users`;
export const deleteUsersEndpoint = (id: string) => `partners/users/${id}`;
export const getUsersByPartnerEndpoint = (
  partnerId: string,
  page: number,
  size: number,
  // ) => `partners/users/${partnerId}?page=${page}&size=${size}`;
) => `partners/${partnerId}/users?page=${page}&size=${size}`;
// https://tunisiaapi.edfapay.com/partners/c321aca5-f51d-4940-b59a-6e2c437b7d30/users
export const getAllUsersByPartnerIdEndPoint = (partnerId: string) =>
  `partners/${partnerId}/users`;

export const getAuditLogsEndpoint = (
  pageNumber: number,
  pageSize: number,
  id?: any,
  name?: any,
  action?: any,
  userName?: any,
  ip?: any,
  applicationName?: any,
) => {
  return `audit/find/?pageNumber=${pageNumber}&pageSize=${pageSize}&id=${id}&name=${name}&action=${action}&userName=${userName}&ip=${ip}&applicationName=${applicationName}`;
};

export const getPaymentGatewayListEndpoint = (
  filters: any,
  pageNumber: number,
  pageSize: number,
  partnerId?: any,
) => {
  return `payment/filter?orderId=${filters.orderId}&merchant_id=${filters.merchant_id}&action=${filters.action}&order_currency=${filters.order_currency}&order_amount=${filters.order_amount}&card_number=${filters.card_number}&payer_country=${filters.payer_country}&payer_email=${filters.payer_email}&payer_phone=${filters.payer_phone}&term_url_3ds=${filters.term_url_3ds}&gwayPaymentId=${filters.gwayPaymentId}&gway_payment_status=${filters.gway_payment_status}&payer_city=${filters.payer_city}&amountFrom=${filters.amountFrom}&amountTo=${filters.amountTo}&startDate=${filters.startDate}&endDate=${filters.endDate}&partnerId=${partnerId}&pageNumber=${pageNumber}&pageSize=${pageSize}`; //&duplicatePayment=
};

export const getApplePayTransactionEndpoint = (
  pageNumber: any,
  pageSize: any,
  dates: { startDate?: string; endDate?: string },
  sortDirection: any,
  merchantKey: any,
  partnerId: any,
  formData: {
    id?: string;
    city?: string;
    zip?: string;
    name?: string;
    ip?: string;
    address?: string;
    options?: string;
    email?: string;
    country?: string;
    description?: string;
    amount?: string;
    amountFrom?: string;
    amountTo?: string;
    number?: string;
    currency?: string;
    methods?: string;
    cancel_url?: string;
    operation?: string;
    success_url?: string;
    password?: string;
    hash?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    refunded?: string;
    merchant_origin?: string;
    cardScheme?: string;
    merchantID?: string;
  },
) => {
  const queryParams = [];

  if (dates.startDate) {
    queryParams.push(`startDate=${encodeURIComponent(dates.startDate)}`);
  }
  if (formData.refunded) {
    queryParams.push(`refunded=${encodeURIComponent(formData.refunded)}`);
  }
  if (dates.endDate) {
    queryParams.push(`endDate=${encodeURIComponent(dates.endDate)}`);
  }
  if (formData.amount) {
    queryParams.push(`amount=${encodeURIComponent(formData.amount)}`);
  }
  if (formData.name) {
    queryParams.push(`name=${encodeURIComponent(formData.name)}`);
  }
  if (formData.amountFrom) {
    queryParams.push(`amountFrom=${encodeURIComponent(formData.amountFrom)}`);
  }
  if (formData.amountTo) {
    queryParams.push(`amountTo=${encodeURIComponent(formData.amountTo)}`);
  }

  if (formData.city) {
    queryParams.push(`city=${encodeURIComponent(formData.city)}`);
  }
  if (formData.ip) {
    queryParams.push(`ip=${encodeURIComponent(formData.ip)}`);
  }
  if (formData.country) {
    queryParams.push(`country=${encodeURIComponent(formData.country)}`);
  }
  if (formData.number) {
    queryParams.push(`number=${encodeURIComponent(formData.number)}`);
  }
  if (formData.email) {
    queryParams.push(`email=${encodeURIComponent(formData.email)}`);
  }
  if (formData.cardScheme) {
    queryParams.push(`cardScheme=${encodeURIComponent(formData.cardScheme)}`);
  }
  if (formData.operation) {
    queryParams.push(`operation=${encodeURIComponent(formData.operation)}`);
  }
  if (formData.status) {
    queryParams.push(`status=${encodeURIComponent(formData.status)}`);
  }
  if (formData.currency) {
    queryParams.push(`currency=${encodeURIComponent(formData.currency)}`);
    if (sortDirection) {
      queryParams.push(`sortDirection=${encodeURIComponent(sortDirection)}`);
    }
  }
  const queryString = queryParams.length > 0 ? `${queryParams.join("&")}` : "";
  //partnerId=${partnerId}&
  return `applepay/orders?${queryString}&merchantKey=${merchantKey}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
};
export const getApplePayTransaction = (
  merchantId: any,
  partnerId: any,
  pageNumber: any,
  pageSize: any,
) => {
  return `applepay/orders?merchantID=${merchantId}&partnerId=${partnerId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
};

//NEW
export const getAllVersionListEndpoint = (
  pageNumber: any,
  pageSize: any,
  keyword?: any,
  active?: { value: string; label: string }[],
) => {
  return `attestation/getVersions/app?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&active=${active
    ?.map((obj) => obj.value)
    .join(",")}`;
};

export const getVersionDetailsEndpoint = (version: any) => {
  return `attestation/version/${version}`;
};

export const getVersionHistoryEndpoint = (version: any) => {
  return `attestation/versionhistory/${version}`;
};

export const addVersionHistoryEndpoint = () => {
  return `attestation/setversion`;
};

export const deleteVersionEndpoint = (versionId: string) => {
  return `attestation/versions/${versionId}`;
};

export const updateVersionEndpoint = (versionId: string) => {
  return `attestation/versions/${versionId}`;
};

export const getSettlementReportEndpoint = (
  start_date: string,
  end_date: string,
  merchant_id_name: string,
) => {
  return `/payment/settlement-excel?start_date=${encodeURIComponent(
    start_date,
  )}&end_date=${encodeURIComponent(
    end_date,
  )}&merchant_id_name=${encodeURIComponent(merchant_id_name)}`;
};

export const getOnboardingFilesEndpoint = (id: string) =>
  `merchants/filestorage/getNames/${id}`;

export const getPartnerThemeEndpoint = (hostName: any, partnerId?: any) => {
  const queryParams = [];

  if (hostName) {
    queryParams.push(`hostName=${encodeURIComponent(hostName)}`);
  }
  if (partnerId) {
    queryParams.push(`partnerId=${encodeURIComponent(partnerId)}`);
  }
  const queryString = queryParams.length > 0 ? `${queryParams.join("&")}` : "";
  return `/merchants/hosts/configuration/findAll?${queryString}`;
};

export const getHostNameByContactName = (contactName: string) => {
  return `merchants/hosts/by-contact/${contactName}`;
};

export const addNewThemeConfiguration = () => {
  return "merchants/hosts";
};

export const updateThemeConfiguration = (id: number) => {
  return `merchants/hosts/${id}`;
};
export const addpartnerThemeEndpoint = () => `merchants/partner/configuration`;

export const updatepartnerThemeEndpoint = () =>
  `merchants/partner/configuration/update`;

export const deactivatepartnerThemeEndpoint = (hostName: any) =>
  `merchants/partner/configuration/deactivate?hostName=${hostName}`;

export const getSummeryDetailsEndpoint = () => {
  return `transactions/financial/summary`;
};

export const getpaymentMethodsDetailsEndpoint = () => {
  return `transactions/financial/cardtype`;
};
export const getTopMerchantEndpoint = () => {
  return `transactions/financial/topMerchants/`;
};

export const getTopMerchantsV2Endpoint = () => {
  return `transactions/financial/topMerchantsV2`;
};

export const getTerminalActivityEndpoint = () => {
  return `transactions/financial/terminalActivity`;
};
export const getTrxAmountsForChartEndpoint = () => {
  return `transactions/financial/amount/`;
};

export const getTrxCountForChartEndpoint = () => {
  return `transactions/financial/count`;
};

export const getTerminalsBreifEndpoint = (partnerId: string) => {
  return `terminals/totalTerminals/?partnerID=${partnerId ? partnerId : ""}`;
};

export const getPartnerSummeryEndpoint = () => {
  return `merchants/partner/summary/`;
};

export const getPartnerTrxDetailsEndpoint = () => {
  return `transactions/financial/partnertransactionsummaries`;
};

export const getTrxRequestLogEndpoint = (
  pageSize: number,
  pageNumber: number,
  filterValues?: {
    dates: {
      startDate: string;
      endDate: string;
    };
    tsn: string;
    rnn: string;
    cardNumber: string;
    trxId: string;
    amount: string;
  },
) => {
  const queryParams = [];

  if (filterValues?.dates?.startDate) {
    queryParams.push(
      `startDate=${encodeURIComponent(filterValues?.dates.startDate)}`,
    );
  }
  if (filterValues?.dates?.endDate) {
    queryParams.push(
      `endDate=${encodeURIComponent(filterValues?.dates.endDate)}`,
    );
  }
  if (filterValues?.trxId) {
    queryParams.push(`trxId=${encodeURIComponent(filterValues.trxId)}`);
  }

  if (filterValues?.amount) {
    queryParams.push(`amount=${encodeURIComponent(filterValues.amount)}`);
  }
  if (filterValues?.tsn) {
    queryParams.push(`tsn=${encodeURIComponent(filterValues.tsn)}`);
  }
  if (filterValues?.rnn) {
    queryParams.push(`rrn=${encodeURIComponent(filterValues.rnn)}`);
  }
  if (filterValues?.cardNumber) {
    queryParams.push(
      `cardNumber=${encodeURIComponent(filterValues.cardNumber)}`,
    );
  }

  const queryString = queryParams.length > 0 ? `${queryParams.join("&")}` : "";

  return `transactions/filterRequestTrxLogs?pageSize=${pageSize}&pageNumber=${pageNumber}&${queryString}`;
};

export const getTrxResponseLogEndpoint = (
  pageSize: number,
  pageNumber: number,
  filterValues?: {
    dates: {
      startDate: string;
      endDate: string;
    };
    tsn: string;
    rnn: string;
    cardNumber: string;
    trxId: string;
    amount: string;
    cardType: { value: string; label: string }[];
    madaTerminalId: string;
    AppId: string;
  },
) => {
  const queryParams = [];

  if (filterValues?.dates?.startDate) {
    queryParams.push(
      `startDate=${encodeURIComponent(filterValues?.dates.startDate)}`,
    );
  }
  if (filterValues?.dates?.endDate) {
    queryParams.push(
      `endDate=${encodeURIComponent(filterValues?.dates.endDate)}`,
    );
  }
  if (filterValues?.trxId) {
    queryParams.push(`trxId=${encodeURIComponent(filterValues.trxId)}`);
  }

  if (filterValues?.amount) {
    queryParams.push(`amount=${encodeURIComponent(filterValues.amount)}`);
  }
  if (filterValues?.tsn) {
    queryParams.push(`tsn=${encodeURIComponent(filterValues.tsn)}`);
  }
  if (filterValues?.rnn) {
    queryParams.push(`rrn=${encodeURIComponent(filterValues.rnn)}`);
  }
  if (filterValues?.cardNumber) {
    queryParams.push(
      `cardNumber=${encodeURIComponent(filterValues.cardNumber)}`,
    );
  }
  if (filterValues?.cardType) {
    queryParams.push(
      `cardType=${encodeURIComponent(
        filterValues.cardType.map((obj) => obj.value).join(","),
      )}`,
    );
  }
  if (filterValues?.madaTerminalId) {
    queryParams.push(
      `madaTerminalId=${encodeURIComponent(filterValues.madaTerminalId)}`,
    );
  }
  if (filterValues?.AppId) {
    queryParams.push(`AppId=${encodeURIComponent(filterValues.AppId)}`);
  }
  const queryString = queryParams.length > 0 ? `${queryParams.join("&")}` : "";
  return `transactions/filterResponseTrxLogs?pageSize=${pageSize}&pageNumber=${pageNumber}&${queryString}`;
};

export const getClickToPayTransactionEndpoint = (merchantId?: string) => {
  return `/clictopay/order-list?edfa_merchant_id=${merchantId}`;
};

export const getClickToPayTransactionForAll = (merchantId?: string) => {
  return `/clictopay/order-list`;
};

export const getAMSThreatsEndpoint = (
  pageNo: number,
  pageSize: number,
  filterValues?: {
    dates: {
      startDate: string;
      endDate: string;
    };
    deviceId: string;
    deviceModel: string;
    app_version: string;
    appId: string;
    configName: string;
  },
) => {
  const queryParams = [];

  if (filterValues?.dates?.startDate) {
    queryParams.push(
      `startDate=${encodeURIComponent(filterValues?.dates.startDate)}`,
    );
  }
  if (filterValues?.dates?.endDate) {
    queryParams.push(
      `endDate=${encodeURIComponent(filterValues?.dates.endDate)}`,
    );
  }
  if (filterValues?.deviceId) {
    queryParams.push(`deviceId=${encodeURIComponent(filterValues.deviceId)}`);
  }
  if (filterValues?.deviceModel) {
    queryParams.push(
      `deviceModel=${encodeURIComponent(filterValues.deviceModel)}`,
    );
  }
  if (filterValues?.app_version) {
    queryParams.push(
      `app_version=${encodeURIComponent(filterValues.app_version)}`,
    );
  }
  if (filterValues?.appId) {
    queryParams.push(`appId=${encodeURIComponent(filterValues.appId)}`);
  }
  if (filterValues?.configName) {
    queryParams.push(
      `&configName=${encodeURIComponent(filterValues.configName)}`,
    );
  }
  const queryString = queryParams.length > 0 ? `${queryParams.join("&")}` : "";
  return `attestation-and-monitoring/fetchThreats?PageSize=${pageSize}&pageNumber=${pageNo}${queryString}`;
};

export const getAllSummaryThreadsEndpoint = (
  startDate?: string,
  endDate?: string,
) => {
  return `attestation-and-monitoring/getAllSummaryThreats?startDate=${startDate}&endDate=${endDate}`;
};

export const getTop3DetectionNameFromMerchantControlEndpoint = (
  startDate?: string,
  endDate?: string,
) => {
  return `attestation-and-monitoring/getTop3DetectionName?startDate=${startDate}&endDate=${endDate}`;
};

export const getTop5TerminalIdFromMerchantControlEndpoint = (
  startDate?: string,
  endDate?: string,
) => {
  return `attestation-and-monitoring/getTop5TerminalId?startDate=${startDate}&endDate=${endDate}`;
};

export const getDataByDateFromMerchantControlEndpoint = (
  startDate?: string,
  endDate?: string,
) => {
  return `attestation-and-monitoring/getRecordByStartAndEndDate?startDate=${startDate}&endDate=${endDate}`;
};
export const addCNFGEndpoint = () => {
  return `application/config`;
};
export const GetCNFGEndpoint = (
  selectedPartnerCard: string,
  configType?: string,
) => {
  var queryParams = [];
  if (configType) {
    queryParams.push(`configType=${configType}`);
  }
  return `application/config/${selectedPartnerCard}?${queryParams.join("&")}`;
};
export const updateDeleteCNFGEndpoint = (
  code: string,
  type: string,
  key: string,
) => {
  return `application/config/${code}/${type}/${key}`;
};

export const getSdkTokenEndpoint = (merchantId: string, userId: string) => {
  return `/merchants/${merchantId}/generateToken/${userId}`;
};

export const getActiveFeed = (
  orderId: string,
  pageNumber = 1,
  pageSize = 10,
) => {
  return `/recurring-payments/order/${orderId}/notes?pageNumber=1&pageSize=10?pageNumber=${pageNumber}&pageSize=${pageSize}`;
};

export const plansSummaryEndpoint = () => `/recurring-payments/plans/summary`;

export const recurringPlansEndpoint = () => `/recurring-payments/plans`;
export type RecurringPlansFilter = {
  name?: string;
  termLength?: number;
  termLengthType?: "DAY" | "WEEK" | "MONTH" | "YEAR";
  paymentFrequency?: "DAILY" | "WEEKLY" | "MONTHLY" | "ANNUAL";
  upperAmount?: number;
  lowerAmount?: number;
  maximumPayablePercentage?: number;
  minimumPayablePercentage?: number;
  status?: "ACTIVE" | "INACTIVE";
};

export const recurringPlansEndpointMerchant = (id: string) =>
  `/recurring-payments/merchants/schedules/summary/${id}`;

export const plansSummaryMerchantEndpoint = (id: string) =>
  `/recurring-payments/merchants/schedules/summary/${id}`;

// export const plansSummaryMerchantEndpoint = () =>
//   `/recurring-payments/merchants/schedules/summary/76e06a49-abf5-42cc-81fb-0418f3a20efe`;

export const recurringPlansGetAllMerchantEndpoint = () =>
  `/recurring-payments/merchants`;
export const register_deRegisterEndpoint = (merchantId: string | number) =>
  `/merchants/${merchantId}/recurring`;

export const recurringPartnerPlansEndpoint = () =>
  `/recurring-payments/partners/plans`;

export const recurringTogglePlansEndpoint = () =>
  `/recurring-payments/plans/bulk/toggle`;

export const recurringToggleSinglePlanEndpoint = (planId: string) => {
  return `/recurring-payments/plans/${encodeURIComponent(planId)}/toggle`;
};

export const recurringAssignPlanToMerchantEndpoint = (planId: string) => {
  return `/recurring-payments/plans/${encodeURIComponent(planId)}/assign`;
};

export const recurringUnassignPlansEndpoint = () =>
  `/recurring-payments/plans/unassign`;

export const recurringPlanDeleteEndpoint = (planId: string) => {
  return `/recurring-payments/plans/${encodeURIComponent(planId)}`;
};

export const createPlanTemplatesEndpoint = (planId: string) => {
  return `/recurring-payments/plans/${planId}/planTemplates`;
};

export const recurringSummaryEndpoint = (planId: string) =>
  `/recurring-payments/plans/${planId}/summary`;

export const triggerRecurringPaymentsEndpoint = (
  planTemplateId: string | number,
) => `/recurring-payments/payments/${planTemplateId}/pay`;

export const recurringPlanGetMerchantsEndpoint = () =>
  `/recurring-payments/merchants`;

export const recurringPlansGetAllMerchantByPartnerEndpoint = () =>
  `/recurring-payments/partners/me/merchants`;

export const recurringGetPlanSchedulesEndpoint = (planId: string) =>
  `/recurring-payments/payments/recurring/${planId}`;

export const recurringPlansByAmountEndpoint = (merchantId: string) =>
  `/recurring-payments/plans/${merchantId}/by-amount`;

export const recurringPlansForMerchantsByAmountEndpoint = (
  merchantId: string,
) => `/recurring-payments/merchants/${merchantId}/plans`;

export const recurringPlansDuplicateEndpoint = (planId: string) =>
  `/recurring-payments/plans/${planId}/duplicate`;

export const recurringPaymentsEndpoint = (invoiceId: string) => {
  return `/recurring-payments/payments/${invoiceId}/recurring`;
};

export const saveRecurrenceTermsAcceptanceEndpoint = () =>
  `/recurring-payments/payments/accept`;

export const bulkActionsEndpoint = (orderId: string) =>
  `recurring-payments/payments/${orderId}/bulk-actions`;

export const sendPaymentLinkEndpoint = (planTemplateId: number) =>
  `/recurring-payments/payments/${planTemplateId}/send-link`;

export const sendPaymentReminderEndpoint = (planTemplateId: number) =>
  `/recurring-payments/payments/${planTemplateId}/reminders`;

export const updatePaymentStatusEndpoint = (planTemplateId: number) =>
  `/recurring-payments/payments/planTemplates/${planTemplateId}/status`;

export const getSummaryStatusEndpoint = (orderId: string) =>
  `recurring-payments/payments/${orderId}/summary-status`;

export const cancelPaymentScheduleEndpoint = (invoiceId: string | number) =>
  `recurring-payments/payments/${invoiceId}/cancel`;

export const refundPaymentScheduleEndpoint = (
  planTemplateId: string | number,
) => `recurring-payments/payments/${planTemplateId}/refund`;

export const getRecurringPaymentConfig = () =>
  `recurring-payments/configurations`;

export const getInvoiceDownloadUrl = () =>
  `recurring-payments/invoice/download`;

export const getLatestTermsEndpoint = () => `recurring-payments/terms/latest`;

export const downloadTermsPdfEndpoint = (orderId: string) =>
  `recurring-payments/orders/${orderId}/legal-bindings`;

export const getTermsAcceptanceEndpoint = (orderId: string) =>
  `recurring-payments/orders/${orderId}/terms`;

export const getRecurringPaymentsEndpoint = (
  merchantId?: string,
  invoiceId?: string,
  pageNumber?: number,
  pageLength?: number,
) => {
  const queryParams = [];
  if (merchantId) queryParams.push(`merchantId=${merchantId}`);
  if (invoiceId) queryParams.push(`invoiceId=${invoiceId}`);
  if (pageNumber !== undefined) queryParams.push(`pageNumber=${pageNumber}`);
  if (pageLength !== undefined) queryParams.push(`pageLength=${pageLength}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return `recurring-payments/payments${queryString}`;
};

export const getAllPartnerHosts = (pageSize?: number, pageNumber?: number) =>
  `merchants/hosts/summaries/${pageSize ? `?pageSize=${pageSize}` : ""}${
    pageNumber ? `&pageNumber=${pageNumber}` : ""
  }`;

export const getAllPartners = () => `partners`;

export const getPartnerHostDetails = (hostId: number) =>
  `merchants/hosts/${hostId}/details`;

export const addPartnerHost = () => "partners/hosts";

export const updatePartnerHost = () => "partners/hosts/bulk";

export const getAdminTerminalFilesEndpoint = (page = 0, size = 50) =>
  `admin/terminal-files?page=${page}&size=${size}`;

export const getAdminTerminalFileDownloadEndpoint = (terminalFileId: number) =>
  `admin/terminal-files/${terminalFileId}/download`;

export type OperationalReportQueryParams = {
  startDate: string;
  endDate: string;
  partnerId?: string;
  partnerIds?: string[];
  page?: number;
  size?: number;
  activityStatus?: string;
};

const buildOperationalReportQuery = (
  params: OperationalReportQueryParams,
  includePagination = true,
) => {
  const queryParams: string[] = [
    `startDate=${encodeURIComponent(params.startDate)}`,
    `endDate=${encodeURIComponent(params.endDate)}`,
  ];

  if (params.partnerIds?.length) {
    params.partnerIds.forEach((id) =>
      queryParams.push(`partnerId=${encodeURIComponent(id)}`),
    );
  } else if (params.partnerId) {
    queryParams.push(`partnerId=${encodeURIComponent(params.partnerId)}`);
  }

  if (params.activityStatus && params.activityStatus !== "ALL") {
    queryParams.push(
      `activityStatus=${encodeURIComponent(params.activityStatus)}`,
    );
  }

  if (includePagination) {
    queryParams.push(`page=${params.page ?? 0}`);
    queryParams.push(`size=${params.size ?? 10}`);
  }

  return queryParams.join("&");
};

/** GET paginated merchant activity (Postman: /transactions/merchants/activity) */
export const merchantActivityEndpoint = (
  params: OperationalReportQueryParams,
) =>
  `transactions/merchants/activity?${buildOperationalReportQuery(params, true)}`;

/** GET merchant activity Excel export */
export const merchantActivityDownloadEndpoint = (
  params: OperationalReportQueryParams,
) =>
  `transactions/merchants/activity/download?${buildOperationalReportQuery(
    params,
    false,
  )}`;
